import { DOCUMENT } from '@angular/common';
import { AfterViewInit, DestroyRef, Directive, ElementRef, EventEmitter, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, fromEvent } from 'rxjs';

@Directive({
  selector: '[clickOutside]',
  standalone: true,
})
export class ClickOutsideDirective implements AfterViewInit {
  @Output() public onClickOutside = new EventEmitter<void>();

  public ngAfterViewInit(): void {
    fromEvent(this.document, 'mousedown')
      .pipe(
        filter((event) => !this.isInside(event.target as HTMLElement)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.onClickOutside.emit());
  }

  private isInside(elementToCheck: HTMLElement): boolean {
    return elementToCheck === this.elementRef.nativeElement || this.elementRef.nativeElement.contains(elementToCheck);
  }

  private readonly elementRef = inject(ElementRef);
  private readonly document = inject(DOCUMENT);
  private readonly destroyRef = inject(DestroyRef);
}
